import { Loader2, Pencil } from 'lucide-react';
import React, { useState } from 'react';

import { RefreshToken } from '@crossnokaye/typescript-sdk/models/components';
import { Button, withTooltip } from '@crossnokaye/ux-common';
import { ConditionalRender } from '@crossnokaye/ux-smarts';

import { EditTokenDrawer } from '@/features/tokens/components/edit-token-drawer/edit-token-drawer';

const ButtonWithTooltip = withTooltip(Button);

interface EditTokenActionProps {
  token: RefreshToken;
  isLoading?: boolean;
}

export const EditTokenAction: React.FC<EditTokenActionProps> = ({ token, isLoading = false }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleEdit = () => {
    setIsDrawerOpen(true);
  };

  return (
    <>
      <ButtonWithTooltip
        variant={'ghost'}
        size={'icon'}
        onClick={handleEdit}
        disabled={isLoading}
        className={'h-8 w-8'}
        tooltipContent={
          <span className={'flex flex-row gap-2 items-center'}>
            <Pencil className={'h-4 w-4'} />
            {'Edit Token'}
          </span>
        }
      >
        <ConditionalRender condition={isLoading} fallback={<Pencil className={'h-4 w-4'} />}>
          <Loader2 className={'h-4 w-4 animate-spin'} />
        </ConditionalRender>
      </ButtonWithTooltip>
      <EditTokenDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} token={token} />
    </>
  );
};
